// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M20 3V0H18V3H15V5H18V8H20V5H23V3H20Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13.5 4C13.5 3.6585 13.5311 3.32428 13.5907 3H4V22.9432L12 17.2289L20 22.9432V9.40931C19.6757 9.46888 19.3415 9.5 19 9.5C15.9624 9.5 13.5 7.03757 13.5 4Z"}}]};

const BookmarkAddFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'bookmark-add-filled',
    ref,
    icon: element,
  },
));

BookmarkAddFilledIcon.displayName = 'BookmarkAddFilledIcon';

export default BookmarkAddFilledIcon;
